import { isEmpty } from 'lodash';
import { useCallback, forwardRef, useEffect, useImperativeHandle } from 'react';

import FiltersContent from './FiltersContent';

const updateFilters = (filters, values) => {
  Object.keys(values).forEach((key) => {
    if (
      isEmpty(values[key]) ||
      (key === 'location' && values[key].location === '')
    ) {
      delete filters[key];
    } else {
      filters[key] = values[key];
    }
  });

  return filters;
};

const BlockFilters = forwardRef(
  (
    {
      actionButtonsCanOverflow,
      blockData,
      blockQuery,
      setBlockQuery,
      data,
      dataTestId,
      filters,
      filtersByRow,
      filterRows,
      forceEnableClearFilters = (data) => data?.['block-tags'], // See react/frontoffice/components/BlocksRenderer/shared.jsx,
      modal,
      clearFilters,
      setBlockData,
      header,
    },
    ref,
  ) => {
    const handleChangeFilters = useCallback(
      (values) => {
        if (!values) {
          setBlockQuery(null);
        } else {
          setBlockQuery((prevQuery) => updateFilters(prevQuery, values));
        }
      },
      [setBlockQuery],
    );

    useImperativeHandle(ref, () => ({
      clearFilters,
    }));

    useEffect(() => {
      setBlockData(blockQuery);
    }, [blockQuery, setBlockData]);

    useEffect(() => {
      if (blockData === null) {
        handleChangeFilters(null);
      }
    }, [blockData, handleChangeFilters]);

    if (!filters?.length) return null;

    return (
      <FiltersContent
        dataTestId={dataTestId}
        filters={filters}
        filtersByRow={filtersByRow}
        filterRows={filterRows}
        onChangeFilters={handleChangeFilters}
        clearFilters={clearFilters}
        values={blockQuery}
        modal={modal}
        actionButtonsCanOverflow={actionButtonsCanOverflow}
        forceEnableClearFilters={forceEnableClearFilters?.(data)}
        header={header}
      />
    );
  },
);

export default BlockFilters;
